module.exports = __webpack_public_path__ + "img/fenetrePopup.dce63a20.png";